import { notifications } from "@mantine/notifications";
import type { ReactNode } from "react";
import styles from "./notifications.module.css";

export const showErrorNotification = ({
  message,
  title,
}: {
  message: ReactNode;
  title?: string;
}) => {
  return notifications.show({
    title,
    message,
    color: "red",
    withCloseButton: true,
    autoClose: 10000,
    classNames: {
      root: styles.errorRoot,
      description: styles.errorDescription,
      title: styles.errorTitle,
      closeButton: styles.errorCloseButton,
    },
  });
};

export const showSuccessNotification = ({
  message,
  title,
}: {
  message: string;
  title?: string;
}) => {
  return notifications.show({
    title,
    message,
    color: "green",
    withCloseButton: true,
    autoClose: 5000,
    classNames: {
      root: styles.successRoot,
      description: styles.successDescription,
      title: styles.successTitle,
      closeButton: styles.successCloseButton,
    },
  });
};

export const showWarningNotification = ({
  message,
  title,
}: {
  message: ReactNode;
  title?: string;
}) => {
  return notifications.show({
    title,
    message,
    color: "orange",
    withCloseButton: true,
    autoClose: 10000,
    classNames: {
      root: styles.warningRoot,
      description: styles.warningDescription,
      title: styles.warningTitle,
      closeButton: styles.warningCloseButton,
    },
  });
};

export const showLoadingNotification = ({
  message,
  title,
  autoClose,
}: {
  message: string;
  title?: string;
  autoClose?: boolean | number;
}) => {
  return notifications.show({
    title,
    message,
    color: "blue",
    loading: true,
    autoClose: autoClose,
    classNames: {
      root: styles.infoRoot,
      description: styles.infoDescription,
      title: styles.infoTitle,
      closeButton: styles.infoCloseButton,
    },
  });
};
